import { NotebookPreviewWrapper } from './NotebookPreview';

export default NotebookPreviewWrapper;
